import React, { useState, useEffect } from "react";
import {
    Checkbox,
    DialogContent,
    FormControl,
    FormControlLabel,
    Grid,
    Box,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    TextField,
    Typography,
    DialogTitle,
    DialogActions,
    useMediaQuery,
    Slide
} from "@mui/material";
import { useAtom } from "jotai";
import CircularProgress from "@mui/material/CircularProgress";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { customLocale } from "../../utils/CalendarFunctions/CalendarConfig";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Button } from "@mui/material";
import moment from "moment";
import { parseISO } from "date-fns";
import Dialog from "@mui/material/Dialog";
import { graphql, graphqlOperation } from "../../modules/AmplifyServices";
import { getPromo } from "../../graphql/queries";
import { useTheme } from "@emotion/react";
import {
    conformationDialogOpenAtom,
    conformationDialogContentAtom,
    confirmationFunctionAtom,
    conformationDialogTitleAtom,
    conformationDialogSubmitButtonAtom,
    conformationDialogIsSubmittingAtom
} from "../../atoms/atoms";
import { userPageSnackbarAtom } from "../../atoms/usersTable";

const getDate = () => {
    let date = new Date().toISOString();
    return date;
};
const PROMO_CODE_REGEX = /^[a-zA-Z0-9]+$/;

const today = new Date();

function AddPromoCodeModal(props) {
    const [promoStatus, setPromoStatus] = useState("active");
    const [terminated, setTerminated] = useState(false);
    const [name, setName] = useState("");
    const [nameError, setNameError] = useState(false);
    const [promoCode, setPromocode] = useState("");
    const [promoCodeError, setPromoCodeError] = useState(false);
    const [promoCodeNotUniqueError, setPromoCodeNotUniqueError] =
        useState(false);
    const [discountError, setDiscountError] = useState(false);
    const [descriptionError, setDescriptionError] = useState(false);
    const [startDate, setStartDate] = useState(getDate());
    const [endDate, setEndDate] = useState(moment().add(10, "years"));
    const [createdAt, setCreatedAt] = useState("");
    const [discountValue, setDiscountValue] = useState("");
    const [discountType, setDiscountType] = useState("PERCENTAGE");
    const [applyDiscount, setApplyDiscount] = useState("allservices");
    const [selectedServicesIds, setSelectedServicesIds] = useState(
        props.serviceTypes.map((service) => service.id)
    );
    const [selectedServices, setSelectedServices] = useState(
        props.serviceTypes
    );
    const [selectedPackageIds, setSelectedPackageIds] = useState(
        props.pkgs.map((pkg) => pkg.id)
    );
    const [selectedPackages, setSelectedPackages] = useState(props.pkgs);
    const [allPackages, setAllPackages] = useState(false);
    const [allServices, setAllServices] = useState(false);
    const [onePerClient, setOnePerClient] = useState(false);
    const [hasExpiryDate, setHasExpiryDate] = useState(false);
    const [maxNumOfRedemptions, setMaxNumOfRedemptions] = useState(0);
    const [promo, setPromo] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [disableSave, setDisableSave] = useState(false);
    const [openStartDate, setOpenStartDate] = useState(false);
    const [openEndDate, setOpenEndDate] = useState(false);

    const [, setConfirmationDialogContent] = useAtom(
        conformationDialogContentAtom
    );
    const [, setConfirmationFunction] = useAtom(confirmationFunctionAtom);
    const [, setConfirmationDialogOpen] = useAtom(conformationDialogOpenAtom);
    const [, setConformationDialogTitle] = useAtom(conformationDialogTitleAtom);
    const [, setConformationDialogSubmitButton] = useAtom(
        conformationDialogSubmitButtonAtom
    );
    const [, setConformationDialogIsSubmitting] = useAtom(
        conformationDialogIsSubmittingAtom
    );
    const [, setUserPageSnackbar] = useAtom(userPageSnackbarAtom);

    useEffect(() => {
        async function fetchPromoData() {
            setIsError(false);
            setIsLoading(true);

            try {
                let result = await graphql(
                    graphqlOperation(getPromo, {
                        id: props.promoCodeId,
                        recordType: "SETTINGS"
                    })
                );
                let promo = result.data.getPromo;
                let details = JSON.parse(promo.Details);
                if (details) for (let pro in details) promo[pro] = details[pro];

                setPromo(promo);
                setLocalState(promo);
            } catch (error) {
                setIsError(true);
            }
            setIsLoading(false);
        }
        if (props.editMode && props.promoCodeId) fetchPromoData();
    }, [props.editMode, props.promoCodeId]);

    useEffect(() => {
        if (selectedPackageIds.length > 0) {
            let pkgsArray = [];
            selectedPackageIds.forEach((item) => {
                let propPkg = props.pkgs.filter((p) => p.id === item);
                if (propPkg.length > 0) {
                    return pkgsArray.push(...propPkg);
                }
            });
            setSelectedPackages((prevState) => pkgsArray);
        }
    }, [selectedPackageIds, props.pkgs]);

    useEffect(() => {
        if (selectedServicesIds.length > 0) {
            let servicesArray = [];
            selectedServicesIds.forEach((item) => {
                const propService = props.serviceTypes.find(
                    (s) => s.id === item
                );
                if (propService) {
                    servicesArray.push(propService);
                }
            });
            setSelectedServices(servicesArray);
        }
    }, [selectedServicesIds, props.serviceTypes]);

    function setLocalState(promoData) {
        setPromocode(promoData.promocode);
        setName(promoData.name);
        setStartDate(getDateFromUTCDateString(promoData.startDate));
        if (promoData.endDate) {
            setEndDate(getDateFromUTCDateString(promoData.endDate));
            setHasExpiryDate(true);
        }
        setDiscountValue(promoData.discountValue);
        setDiscountType(promoData.discountType);
        setOnePerClient(promoData.onePerClient);
        setTerminated(promoData.terminated);
        setAllPackages(promoData.allPackages);
        setAllServices(promoData.allServices);
        setMaxNumOfRedemptions(promoData.maxNumOfRedemptions);
        setPromoStatus(promoData.active ? "active" : "inactive");
        setCreatedAt(promoData.createdAt);
        if (promoData.allPackages) setApplyDiscount("allpackages");
        if (promoData.allServices) setApplyDiscount("allservices");
        if (promoData.services) {
            setApplyDiscount("specificservices");
            setSelectedServices(promoData.services);
            setSelectedServicesIds(promoData.services.map((s) => s.id));
        }
        if (promoData.packages) {
            setApplyDiscount("specificpackages");
            setSelectedPackages(promoData.packages);
            setSelectedPackageIds(promoData.packages.map((p) => p.id));
        }
    }

    const handleDeletePromocode = async () => {
        setConformationDialogIsSubmitting(true);
        try {
            const { success = false } = await props.terminatePromoHandler(
                promo
            );
            if (success) {
                setUserPageSnackbar({
                    open: true,
                    message: "Promo code has been successfully deleted",
                    severity: "success"
                });
                setConformationDialogIsSubmitting(false);
                setConfirmationDialogOpen(false);
                props.closeAddPromoModal();
            } else {
                setUserPageSnackbar({
                    open: true,
                    message: `Unexpected error while deleteing promo code`,
                    severity: "error"
                });
                setConformationDialogIsSubmitting(false);
                setConfirmationDialogOpen(false);
                throw new Error("Error deleting promo code.");
            }
        } catch (error) {
            console.log("Error deleting promo code:", error);
            setConformationDialogIsSubmitting(false);
            setConfirmationDialogOpen(false);
        }
    };

    function handlePromoCode(promoCode) {
        if (promoCode.length < 21) {
            setPromocode(promoCode);
            setPromoCodeError(false);
        } else {
            setPromocode(promoCode.slice(0, -1));
            setPromoCodeError(true);
        }
        if (promoCodeNotUniqueError) setPromoCodeNotUniqueError(false);
    }

    function handlePromoCodeName(name) {
        if (name.length < 21) {
            setName(name);
            setNameError(false);
        } else {
            setName(name.slice(0, -1));
            setNameError(true);
        }
    }

    function promoCodeNotUnique() {
        if (promoCode && promoCode !== "" && promoCode !== promo?.promocode) {
            if (props.uniquePromoCodes) {
                if (props.uniquePromoCodes.has(promoCode)) {
                    setPromoCodeNotUniqueError(true);
                    return true;
                }
            }
        }
        return false;
    }

    function hasError() {
        let hasError = false;
        if (!promoCode) {
            setPromoCodeError(true);
            hasError = true;
        }
        if (promoCodeNotUnique()) {
            hasError = true;
        }
        if (!discountValue) {
            setDiscountError(true);
            hasError = true;
        }
        if (!name) {
            setDescriptionError(true);
            hasError = true;
        }
        if (startDate && endDate && endDate < startDate) {
            hasError = true;
        }
        return hasError;
    }

    const savePromoHandler = async () => {
        setDisableSave(true);
        if (hasError()) {
            setDisableSave(false);
            return;
        }

        let promoData = {
            companyId: props.company.id,
            active: promoStatus === "active" ? true : false,
            terminated,
            allPackages: applyDiscount === "allpackages",
            allServices: applyDiscount === "allservices",
            onePerClient: onePerClient,
            maxNumOfRedemptions: maxNumOfRedemptions,
            name,
            promocode: promoCode,
            startDate: getStartDateWithoutTime(startDate),
            endDate: getEndDateWithoutTime(endDate),
            discountValue,
            discountType,
            hasExpiryDate,
            services: selectedServices
        };
        if (promo?.id) promoData.id = promo.id;
        if (hasExpiryDate || promoData.endDate) {
            promoData.endDate = getEndDateWithoutTime(endDate);
            promoData.hasExpiryDate = true;
        }
        if (applyDiscount === "specificservices") {
            promoData.services = selectedServices.map((s) => {
                return { id: s.id, name: s.name };
            });
            promoData.packages = null;
        }
        if (applyDiscount === "specificpackages") {
            promoData.packages = selectedPackages.map((p) => {
                return { id: p.id, name: p.desc };
            });
            promoData.services = null;
        }
        if (promoData.allPackages || promoData.allServices) {
            promoData.services = null;
            promoData.packages = null;
        }
        await props.savePromoHandler(promoData);
    };

    function getStartDateWithoutTime(adateStr) {
        let adate = new Date(adateStr);
        // Extract year, month, and date from the original input
        let year = adate.getFullYear();
        let month = adate.getMonth();
        let day = adate.getDate();
        // Create midnight UTC for the extracted date
        let dateWithoutTime = new Date(Date.UTC(year, month, day));
        return dateWithoutTime.toISOString(); // "YYYY-MM-DDT00:00:00.000Z"
    }

    function getEndDateWithoutTime(adateStr) {
        let adate = new Date(adateStr);
        let year = adate.getFullYear();
        let month = adate.getMonth();
        let day = adate.getDate();
        // Use 23:59:59 for end of day
        let dateWithoutTime = new Date(
            Date.UTC(year, month, day, 23, 59, 59, 0)
        );
        return dateWithoutTime.toISOString(); // "YYYY-MM-DDT23:59:59.000Z"
    }

    function getDateFromUTCDateString(dateStr) {
        const utcDate = parseISO(dateStr);
        const year = utcDate.getUTCFullYear();
        const month = utcDate.getUTCMonth();
        const day = utcDate.getUTCDate();
        return new Date(year, month, day);
    }

    function handleOnePerClientSwitch(event) {
        setOnePerClient(event.target.checked);
    }

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"), {
        defaultMatches: true
    });
    const SlideTransition = React.forwardRef(function Transition(props, ref) {
        return <Slide direction="left" ref={ref} {...props} />;
    });

    return (
        <Dialog
            open={props.openAddPromoModal}
            onClose={() => {
                props.closeAddPromoModal();
            }}
            fullWidth
            maxWidth={"md"}
            fullScreen={!isDesktop}
            TransitionComponent={!isDesktop ? SlideTransition : "Fade"}
        >
            <DialogTitle variant="h3" sx={{ paddingBottom: "18px" }}>
                {props.editMode ? "Edit " : "Add "} promo code
            </DialogTitle>

            <DialogContent>
                <Grid container>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        sx={{
                            paddingTop: "18px"
                        }}
                    >
                        <FormControlLabel
                            control={
                                <Switch
                                    id="active-promo-code"
                                    name="active"
                                    checked={promoStatus === "active"}
                                    onChange={(event) => {
                                        const newStatus = event.target.checked
                                            ? "active"
                                            : "inactive";
                                        setPromoStatus(newStatus);
                                    }}
                                />
                            }
                            label={"Active"}
                        />
                    </Grid>

                    <Grid container spacing={2.25} sx={{ marginTop: "0px" }}>
                        <Grid item sm={12} md={6}>
                            <TextField
                                id="promo-code"
                                label="Promo code"
                                type="text"
                                fullWidth
                                size="small"
                                focused={
                                    promoCodeNotUniqueError || promoCodeError
                                }
                                error={
                                    promoCodeNotUniqueError || promoCodeError
                                }
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment
                                            position="end"
                                            sx={{
                                                alignItems: "flex-end"
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontSize: "12px",
                                                    color: promoCodeError
                                                        ? "red"
                                                        : ""
                                                }}
                                            >
                                                {promoCode.length}/20
                                            </Typography>
                                        </InputAdornment>
                                    )
                                }}
                                value={promoCode}
                                onChange={(event) => {
                                    const value = event.target.value;
                                    if (
                                        value !== "" &&
                                        !PROMO_CODE_REGEX.test(value)
                                    ) {
                                        return;
                                    }

                                    handlePromoCode(
                                        event.target.value
                                            ? event.target.value.toUpperCase()
                                            : ""
                                    );
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={6}>
                            <FormControl fullWidth>
                                <InputLabel
                                    id="promo-type-services"
                                    size="small"
                                >
                                    Applies to
                                </InputLabel>
                                <Select
                                    sx={{
                                        "& fieldset": {
                                            "& legend": {
                                                width: "55px"
                                            }
                                        }
                                    }}
                                    defaultValue={"all"}
                                    fullWidth
                                    labelId="promo-type-services"
                                    id="promo-type-services"
                                    value={applyDiscount}
                                    onChange={(e) => {
                                        let val = e.target.value;
                                        setApplyDiscount(val);
                                        if ("allservices") {
                                            setAllServices(true);
                                            setAllPackages(false);
                                        } else if ("allpackages") {
                                            setAllPackages(true);
                                            setAllServices(false);
                                        }
                                    }}
                                >
                                    <MenuItem value={"allservices"}>
                                        All services
                                    </MenuItem>
                                    <MenuItem value={"allpackages"}>
                                        All packages
                                    </MenuItem>
                                    <MenuItem value={"specificservices"}>
                                        Specific services
                                    </MenuItem>
                                    <MenuItem value={"specificpackages"}>
                                        Specific packages
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    {(promoCodeError || promoCodeNotUniqueError) && (
                        <Grid variant="errorTextContainer" item xs={12} sm={6}>
                            <Typography variant="errorText">
                                {promoCodeNotUniqueError
                                    ? "This code already exists"
                                    : !promoCode
                                    ? "Please enter a code"
                                    : ""}
                            </Typography>
                        </Grid>
                    )}
                    {applyDiscount === "specificpackages" && (
                        <Grid
                            container
                            spacing={2.25}
                            sx={{ marginTop: "0px" }}
                        >
                            <Grid item sm={12} md={12}>
                                <FormControl fullWidth>
                                    <InputLabel id="promo-packges" size="small">
                                        Packages
                                    </InputLabel>

                                    <Select
                                        id="promo-pacakges"
                                        labelId="promo-packages"
                                        label="Packages"
                                        value={selectedPackageIds}
                                        fullWidth
                                        multiple
                                        sx={{
                                            "& fieldset": {
                                                "& legend": {
                                                    width: "55px"
                                                }
                                            }
                                        }}
                                        renderValue={(selected) => {
                                            if (
                                                selected.length ===
                                                props.pkgs.length
                                            ) {
                                                return "All packages";
                                            } else if (selected.length === 1) {
                                                const selectedPkg =
                                                    props.pkgs.find(
                                                        (pkg) =>
                                                            pkg.id ===
                                                            selected[0]
                                                    );
                                                return `${selectedPkg.servicetype.name} - ${selectedPkg.desc}`;
                                            } else {
                                                return `${selected.length} packages`;
                                            }
                                        }}
                                        onChange={(e) => {
                                            const {
                                                target: { value }
                                            } = e;
                                            setSelectedPackageIds(
                                                // On autofill we get a stringified value.
                                                typeof value === "string"
                                                    ? value.split(",")
                                                    : value
                                            );
                                        }}
                                    >
                                        {props.pkgs?.map((pkg, index) => (
                                            <MenuItem
                                                key={pkg.id}
                                                value={pkg.id}
                                            >
                                                <Checkbox
                                                    checked={
                                                        selectedPackageIds.indexOf(
                                                            pkg.id
                                                        ) > -1
                                                    }
                                                />

                                                {`${pkg.servicetype.name} - ${pkg.desc}`}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    )}

                    {applyDiscount === "specificservices" && (
                        <Grid
                            container
                            spacing={2.25}
                            sx={{ marginTop: "0px" }}
                        >
                            <Grid item sm={12} md={12}>
                                <FormControl fullWidth>
                                    <InputLabel
                                        id="promo-services"
                                        size="small"
                                    >
                                        Services
                                    </InputLabel>
                                    <Select
                                        id="promo-services"
                                        labelId="promo-services"
                                        label="Services"
                                        value={selectedServicesIds}
                                        fullWidth
                                        multiple
                                        sx={{
                                            "& fieldset": {
                                                "& legend": {
                                                    width: "48px"
                                                }
                                            }
                                        }}
                                        renderValue={(selected) => {
                                            if (
                                                selected.length ===
                                                props.serviceTypes.length
                                            ) {
                                                return "All services";
                                            } else if (selected.length === 1) {
                                                const selectedService =
                                                    props.serviceTypes.find(
                                                        (service) =>
                                                            service.id ===
                                                            selected[0]
                                                    );
                                                return selectedService.name;
                                            } else {
                                                return `${selected.length} services`;
                                            }
                                        }}
                                        onChange={(e) => {
                                            const {
                                                target: { value }
                                            } = e;
                                            setSelectedServicesIds(
                                                // On autofill we get a stringified value.
                                                typeof value === "string"
                                                    ? value.split(",")
                                                    : value
                                            );
                                        }}
                                    >
                                        {props.serviceTypes?.map(
                                            (service, index) => (
                                                <MenuItem
                                                    key={service.id}
                                                    value={service.id}
                                                >
                                                    <Checkbox
                                                        checked={
                                                            selectedServicesIds.indexOf(
                                                                service.id
                                                            ) > -1
                                                        }
                                                    />
                                                    {service.name}
                                                </MenuItem>
                                            )
                                        )}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    )}

                    <Grid container spacing={2.25} sx={{ marginTop: "0px" }}>
                        <Grid item sm={12} md={6}>
                            <TextField
                                sx={{
                                    "& fieldset": {
                                        "& legend": {
                                            width: "60px"
                                        }
                                    }
                                }}
                                id="promo-specific-amount"
                                type="number"
                                label="Max usage"
                                size="small"
                                fullWidth
                                value={
                                    maxNumOfRedemptions === 0
                                        ? ""
                                        : maxNumOfRedemptions
                                }
                                onChange={(e) => {
                                    const inputValue = e.target.value;

                                    // Check if the input is a valid number
                                    // Only allow positive numbers
                                    if (
                                        inputValue === "" ||
                                        (!isNaN(inputValue) && inputValue >= 0)
                                    ) {
                                        const newValue =
                                            inputValue === ""
                                                ? ""
                                                : +inputValue;
                                        setMaxNumOfRedemptions(newValue);
                                    }
                                }}
                                onKeyDown={(e) => {
                                    // Prevent typing the minus (- or e) symbol
                                    if (e.key === "-" || e.key === "e") {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={onePerClient}
                                        onChange={handleOnePerClientSwitch}
                                    />
                                }
                                label="Once per client"
                            />
                        </Grid>
                    </Grid>

                    <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={customLocale}
                    >
                        <Grid
                            container
                            spacing={2.25}
                            sx={{ marginTop: "0px" }}
                        >
                            <Grid item sm={12} md={6}>
                                <DatePicker
                                    id="start-date"
                                    size="small"
                                    label="Valid from"
                                    inputFormat="MMM d, yyyy"
                                    minDate={new Date()}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            fullWidth
                                            inputProps={{
                                                ...params.inputProps,
                                                readOnly: true
                                            }}
                                            helperText={
                                                endDate &&
                                                startDate &&
                                                endDate < startDate
                                                    ? " "
                                                    : ""
                                            }
                                            onClick={(e) =>
                                                setOpenStartDate(true)
                                            }
                                            sx={{
                                                "& .MuiInputAdornment-root": {
                                                    display: "none"
                                                },
                                                "& fieldset": {
                                                    "& legend": {
                                                        width: "54px"
                                                    }
                                                }
                                            }}
                                        />
                                    )}
                                    value={startDate}
                                    open={openStartDate}
                                    onOpen={() => setOpenStartDate(true)}
                                    onClose={() => setOpenStartDate(false)}
                                    onChange={(newValue) =>
                                        setStartDate(newValue)
                                    }
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={6}>
                                <DatePicker
                                    id="end-date"
                                    size="small"
                                    label="Valid until"
                                    inputFormat="MMM d, yyyy"
                                    minDate={startDate || today}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            fullWidth
                                            inputProps={{
                                                ...params.inputProps,
                                                readOnly: true
                                            }}
                                            error={Boolean(
                                                endDate &&
                                                    startDate &&
                                                    endDate < startDate
                                            )}
                                            helperText={
                                                endDate &&
                                                startDate &&
                                                endDate < startDate
                                                    ? "End date cannot be before start date"
                                                    : ""
                                            }
                                            onClick={(e) =>
                                                setOpenEndDate(true)
                                            }
                                            sx={{
                                                "& .MuiInputAdornment-root": {
                                                    display: "none"
                                                },
                                                "& fieldset": {
                                                    "& legend": {
                                                        width: "54px"
                                                    }
                                                }
                                            }}
                                        />
                                    )}
                                    value={endDate}
                                    open={openEndDate}
                                    onOpen={() => setOpenEndDate(true)}
                                    onClose={() => setOpenEndDate(false)}
                                    onChange={(newValue) =>
                                        setEndDate(newValue)
                                    }
                                />
                            </Grid>
                        </Grid>
                    </LocalizationProvider>

                    <Grid container spacing={2.25} sx={{ marginTop: "0px" }}>
                        <Grid item xs={12} sm={12} md={6}>
                            <FormControl fullWidth>
                                <InputLabel id="discount-type" size="small">
                                    Discount type
                                </InputLabel>
                                <Select
                                    id="discount-type"
                                    labelId="discount-type-select-label"
                                    label="Discount type"
                                    defaultValue={"$"}
                                    fullWidth
                                    size="small"
                                    value={discountType}
                                    onChange={(e) =>
                                        setDiscountType(e.target.value)
                                    }
                                >
                                    <MenuItem value={"DOLLAR"}>Dollar</MenuItem>
                                    <MenuItem value={"PERCENTAGE"}>
                                        Percentage
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <TextField
                                id="promo-discount"
                                label="Discount amount"
                                type="text"
                                fullWidth
                                size="small"
                                value={discountValue}
                                error={discountError}
                                focused={
                                    discountError &&
                                    !(promoCodeError || promoCodeNotUniqueError)
                                }
                                onChange={(e) => {
                                    setDiscountError(false);
                                    const value = e.target.value;

                                    // Regex to allow numbers and decimal point (up to 2 decimal places)
                                    const regex = /^\d*\.?\d{0,2}$/;

                                    // If the input matches the regex, update the state
                                    if (regex.test(value) || value === "") {
                                        setDiscountValue(value);
                                    }
                                }}
                                InputProps={{
                                    startAdornment: discountType ===
                                        "DOLLAR" && (
                                        <InputAdornment position="start">
                                            $
                                        </InputAdornment>
                                    ),
                                    endAdornment: discountType ===
                                        "PERCENTAGE" && (
                                        <InputAdornment position="end">
                                            %
                                        </InputAdornment>
                                    )
                                }}
                                InputLabelProps={{
                                    shrink: true
                                }}
                            />
                        </Grid>
                    </Grid>
                    {discountError && !discountValue && (
                        <>
                            <Grid
                                variant="errorTextContainer"
                                item
                                xs={12}
                                sm={6}
                            ></Grid>
                            <Grid
                                variant="errorTextSecondContainer"
                                item
                                xs={12}
                                sm={6}
                            >
                                <Typography variant="errorText">
                                    Please enter a discount amount
                                </Typography>
                            </Grid>
                        </>
                    )}

                    <Grid container spacing={2.25} sx={{ marginTop: "0px" }}>
                        <Grid item xs={12} sm={12}>
                            <TextField
                                id="promo-code-description"
                                name="promoCode"
                                size="small"
                                label="Description"
                                type="text"
                                multiline
                                fullWidth
                                variant="outlined"
                                rows={3}
                                focused={
                                    descriptionError &&
                                    !(
                                        discountError ||
                                        promoCodeError ||
                                        promoCodeNotUniqueError
                                    )
                                }
                                error={descriptionError}
                                sx={{
                                    "& fieldset": {
                                        "& legend": {
                                            width: "60px"
                                        }
                                    }
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment
                                            position="end"
                                            sx={{
                                                alignItems: "flex-end"
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    position: "relative",
                                                    top: "-18px",
                                                    fontSize: "12px",
                                                    color: nameError
                                                        ? "red"
                                                        : ""
                                                }}
                                            >
                                                {name.length}/20
                                            </Typography>
                                        </InputAdornment>
                                    )
                                }}
                                value={name}
                                onChange={(e) => {
                                    setDescriptionError(false);
                                    handlePromoCodeName(e.target.value);
                                }}
                            />
                        </Grid>
                    </Grid>
                    {descriptionError && (
                        <Grid variant="errorTextContainer" item xs={12} sm={12}>
                            <Typography variant="errorText">
                                Please add a description
                            </Typography>
                        </Grid>
                    )}
                    <Grid item>
                        <Typography variant="helperText">
                            Displays on the order summary when code is applied
                        </Typography>
                    </Grid>
                </Grid>

                {props.editMode && (
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        sx={{
                            paddingTop: "18px"
                        }}
                    >
                        <Button
                            variant="text"
                            color="error"
                            onClick={() => {
                                setConfirmationFunction(() =>
                                    handleDeletePromocode()
                                );
                                setConfirmationDialogContent(
                                    <Box>
                                        <Typography
                                            variant="body2"
                                            marginBottom="16px"
                                        >
                                            Are you sure you wish to delete "
                                            {promo.promocode}"?
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            fontWeight="bold"
                                        >
                                            This cannot be undone
                                        </Typography>
                                    </Box>
                                );
                                setConformationDialogTitle("Delete promo code");
                                setConformationDialogSubmitButton("Delete");
                                setConfirmationDialogOpen(true);
                            }}
                            sx={{
                                "&:hover": {
                                    backgroundColor: "transparent !important"
                                }
                            }}
                            disableRipple
                        >
                            <Typography
                                variant="button"
                                sx={{
                                    textTransform: "none",
                                    lineHeight: "16px"
                                }}
                            >
                                {`Delete promo code`}
                            </Typography>
                        </Button>
                    </Grid>
                )}
            </DialogContent>
            <DialogActions>
                <Grid
                    container
                    item
                    gap={"18px"}
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end"
                    }}
                >
                    <Button
                        variant="cancelButton"
                        onClick={() => {
                            props.closeAddPromoModal();
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={disableSave}
                        onClick={async () => await savePromoHandler()}
                    >
                        Save
                    </Button>
                    {disableSave && (
                        <CircularProgress
                            size={24}
                            style={{
                                position: "absolute",
                                color: props.company.primaryColor
                            }}
                        />
                    )}
                </Grid>
            </DialogActions>
        </Dialog>
    );
}

export default AddPromoCodeModal;
